import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={video.coverImage}
          alt={video.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          title={video.title}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

        {video.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
            热门
          </span>
        )}
        {video.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
            新上
          </span>
        )}

        <div className="absolute bottom-2 left-2 right-2">
          <div className="flex items-center justify-between text-background-50 text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
              {video.rating}
            </span>
            <span>{video.duration}</span>
          </div>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {video.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{video.year}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
          <span>{video.views >= 10000 ? `${(video.views / 10000).toFixed(1)}万次播放` : `${video.views}次播放`}</span>
        </div>
      </div>
    </Link>
  );
}